// @codekit-prepend "../../../node_modules/zepto/src/zepto.js"
// @codekit-prepend "../../../node_modules/zepto/src/event.js"
// @codekit-prepend "../../../node_modules/zepto/src/form.js"
// @codekit-prepend "../../../node_modules/zepto/src/ajax.js"
// @codekit-prepend "../../../node_modules/zepto/src/ie.js"
// @codekit-prepend "../../../node_modules/zepto/src/data.js"

// @codekit-prepend "../../../node_modules/Zepto-Cookie/zepto.cookie.js"

// @codekit-prepend "lib/keycode.js"
// @codekit-prepend "lib/string-and.js"
// @codekit-prepend "lib/modal.js"
// @codekit-prepend "lib/autocomplete.js"
// @codekit-prepend "lib/popover.js"
// @codekit-prepend "lib/segmented-select.js"
// @codekit-prepend "lib/numeric-input.js"
// @codekit-prepend "lib/dropdown.js"
// @codekit-prepend "lib/scroll.js"
// @codekit-prepend "lib/video.js"
// @codekit-prepend "lib/html-decode.js"

// @codekit-prepend "navigation.js"
// @codekit-append "map.js"
// @codekit-prepend "picture-loader.js"
// @codekit-prepend "photo-viewer.js"
// @codekit-prepend "period-filter.js"
// @codekit-prepend "type-filter.js"
// @codekit-prepend "sorting.js"
// @codekit-prepend "sharing.js"

window.Application = {
    init: function () {
        Application.initialized = true;
        Application.searchInput = $('#search input[type="search"]');
        Application.searchButton = $('#search .search-button');

        Application.periodFilter = new PeriodFilter({
            onChange: Application.filterPhotos
        }).appendTo($('#filters'));
        Application.typeFilter = new TypeFilter({
            onChange: Application.filterPhotos
        }).appendTo($('#filters'));
        Application.sorting = new Sorting({
            onChange: Application.filterPhotos
        }).appendTo($('#filters'));
        Application.noResults = $('<p class="no-results"/>')
            .html('<h3>Geen resultaten</h3>Er werden helaas geen relevante <span class="type"></span> gevonden<span class="period"></span>.<br/><span class="return">Bekijk alle foto\'s</span>, of pas uw zoekopdracht aan.');
        Application.noResults.find('.return').on('click', Application.resetFilters);
        Application.otherResultsItem = $('<div class="other-results-item"/>');
        Application.otherResults = $('<div class="other-results"/>')
            .on('click', Application.resetFilters)
            .appendTo(Application.otherResultsItem);

        $('#logo').on('click', Navigation.goHome);
        $('#clear-search').on('click', Application.onClearClick);
        $('#minor-logo').on('click', Application.onClearClick);
        $('#city-picker button').on('click', function () { window.location = $(this).data('href'); });
        Application.searchInput.on('input', Application.onSearchInput);
        Application.searchButton.on('click', Application.onSearch);
        $(document).on('stateChanged', Application.onStateChanged);
        $('#tour-controls button.prev').on('click', Navigation.prevWaypoint);
        $('#tour-controls button.next').on('click', Navigation.nextWaypoint);
        $('#tour-controls .closer').on('click', Navigation.goBackToHome);

        Application.searchInput.autocomplete({
            url: Application.searchInput.data('autocomplete'),
            onSelect: Application.onSearch
        });

        $.csrfToken = $('meta[name="csrf-token"]').attr('content');

        Navigation.init();
        WeleerMap.init(Application.ready);

        $(window).on('resize scroll', Application.onScroll);

        $('#map-toggle').on('click', event => {
            $('body').toggleClass('mobile-map');
        })

        let iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

        if (!!navigator.platform) {
            while (iDevices.length) {
                if (navigator.platform === iDevices.pop()){
                    $('body').addClass('ios');
                    break;
                }
            }
        }

        var tokenRenewUrl = $('body').data('token-renew-url');
        setInterval(function(){
            var tokenRequest = new XMLHttpRequest();
            tokenRequest.open('POST', tokenRenewUrl, true);
            tokenRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            tokenRequest.send('token=' + $.csrfToken);
        }, 600000);
    },

    ready: function () {
        Application.onStateChanged();
        $('body').addClass('ready');
        setTimeout(function(){
            $('body').addClass('loaded');
        },1000);
    },

    filterPhotos: function () {
        let types = [];
        for (let type of Application.typeFilter.val()) {
            if (type.checked) types.push(parseInt(type.value, 10));
        }
        const onlyComparable = Application.typeFilter.onlyComparable();
        let yearMin = Application.periodFilter.yearMin;
        let yearMax = yearMin;
        if (yearMin) {
            var accuracy = Application.periodFilter.accuracy;
            if (accuracy == 1) {
                yearMin = yearMin - 9;
                yearMax = yearMax + 9;
            } else if (accuracy == 2) {
                yearMin = 1;
            } else if (accuracy == 3) {
                yearMax = 3000;
            } else if (accuracy == 4) {
                yearMax = Application.periodFilter.yearMax;
                if (!yearMax) yearMin = false;
            }
        }
        if (Navigation.isHome()) {
            $('#content').toggleClass('home-searching', (Application.typeFilter.isFiltered || Application.periodFilter.isFiltered));
        }
        const sortOrder = Application.sorting.sortingVal();
        const highlightTime = $(document.body).data('highlight-' + Application.sorting.highlightVal());
        const photoWrapper = Navigation.current().content.find('.photos');
        let items = photoWrapper.find('.photo-item');
        items.remove().sort((a,b) => {
            a = $(a).data('sort-' + sortOrder), b = $(b).data('sort-' + sortOrder)
            if (sortOrder === 'publication') return a > b ? -1 : (a < b ? 1 : 0)
            else return a > b ? 1 : (a < b ? -1 : 0)
        }).appendTo(photoWrapper);
        items.each(function(){
            let item = $(this);
            let photoYearMin = item.data('year-min');
            let photoType = item.data('type');
            let valid = true;

            if (yearMin && photoYearMin) {
                let photoAccuracy = item.data('year-accuracy');
                let photoYearMax = photoYearMin;
                switch (photoAccuracy) {
                    case 2:
                        photoYearMin = photoYearMin - 9;
                        photoYearMax = photoYearMax + 9;
                        break;
                    case 3:
                        photoYearMin = 0;
                        break;
                    case 4:
                        photoYearMax = 3000;
                        break;
                    case 5:
                        photoYearMax = item.data('year-max');
                        break;
                }
                valid = valid && (photoYearMin <= yearMax && photoYearMax >= yearMin);
            }
            if (photoType) {
                valid = valid && (types.indexOf(photoType) > -1);
            }
            if (onlyComparable) {
                valid = valid && item.hasClass('comparable');
            }
            item.toggleClass('invalid', !valid);
            item.toggleClass('highlighted', highlightTime && (highlightTime < parseInt(item.data('sort-publication'), 10)));
            if (valid) item.removeAttr('aria-hidden');
            else item.attr('aria-hidden', 'true');
        });
        if (WeleerMap.initialized) WeleerMap.filterMarkers(yearMin, yearMax, types, highlightTime, onlyComparable);
        let totalCount = Navigation.current().content.find('.photo-item').length;
        let invalidCount = Navigation.current().content.find('.photo-item.invalid').length;
        if (totalCount === 0 || totalCount > invalidCount) {
            Application.noResults.remove();
            if (invalidCount > 0) {
                Application.otherResults.html('<strong>+ ' + invalidCount + '</strong> ' + (invalidCount === 1 ? 'foto' : 'foto\'s') + ' buiten uw parameters');
                Application.otherResultsItem.appendTo(Navigation.current().content.find('.photos'));
            } else {
                Application.otherResultsItem.remove();
            }
        } else {
            if (yearMin) {
                if (accuracy == 1) Application.noResults.find('.period').text(' rond ' + Application.periodFilter.yearMin);
                else if (accuracy == 2) Application.noResults.find('.period').text(' voor ' + Application.periodFilter.yearMin);
                else if (accuracy == 3) Application.noResults.find('.period').text(' na ' + Application.periodFilter.yearMin);
                else if (accuracy == 4) Application.noResults.find('.period').text(' tussen ' + yearMin + ' en ' + yearMax);
            } else {
                Application.noResults.find('.period').text('');
            }
            Application.noResults.find('.type').text('foto\'s');
            Application.noResults.appendTo(Navigation.current().content);
            Application.otherResultsItem.remove();
        }
        PictureLoader.checkIntersections();
    },
    resetFilters: function () {
        Application.periodFilter.reset();
        Application.typeFilter.reset();
    },
    onLogoClick: function (event) {
        event.preventDefault();
        event.stopPropagation();
        Navigation.goHome();
    },
    onSearchInput: function () {
        Application.searchInput.toggleClass('changed', Application.searchInput.val().trim().length > 0);
    },
    onSearch: function () {
        let query = Application.searchInput.val().trim();
        if (query.length === 0) return Application.onClearClick();
        Application.searchInput.removeClass('changed');
        Navigation.search(query);
    },
    onClearClick: function () {
        if (WeleerMap.initialized) WeleerMap.reset();
        Application.searchInput.removeClass('changed').val('');
        Application.resetFilters();
        Navigation.goBackToHome();
    },
    onStateChanged: function () {
        Application.filterPhotos();
        Application.onScroll();
        if (typeof gtag === 'function') {
            const state = Navigation.current();
            let event = {
                page_location: state.url,
                page_title: state.title || state.searchTerm || ''
            };
            if ($(document.body).data('city')) event.dimension1 = $(document.body).data('city');
            if (state.photo_id) event.dimension2 = state.photo_id;
            if (state.keyword_id) event.dimension3 = state.keyword_id;
            if (state.heritage_id) event.dimension4 = state.heritage_id;

            gtag('event', 'page_view', event)
        }
    },
    onScroll: function () {
        $('body').toggleClass('scrolled', $(window).scrollTop() > 90);
    }
};
